import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ContactusComponent } from './contactus/contactus.component'
import { ContactfilterPipe } from './contactfilter.pipe'
import { ContactusService } from './contactus.service'
import { HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatTableModule } from '@angular/material/table'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ContactformModule } from '../contactform/contactform.module'
import { NgSelectModule } from '@ng-select/ng-select'
import { I18nModule, ConfigModule, UrlModule } from '@spartacus/core'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [ContactusComponent, ContactfilterPipe],
  exports: [ContactusComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    ContactformModule,
    I18nModule,
    NgSelectModule,
    UrlModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['contactusform'],
        },
      },
    }),
  ],
  providers: [ContactusService],
})
export class ContactusModule {}
